import { useEffect } from "react";

const UnityComponent = ({url}) => {
  useEffect(() => {
    const iframe = document.getElementById("game");
    iframe.setAttribute("src", url);
    iframe.credentialless = true;  
  }, [url]);
  return  <iframe id="game" title="Unity Content" width="100%" height="100%"  />;
};

export default UnityComponent;
